export default __webpack_public_path__ + "static/media/rnr-sports-table-5-cn.2bfd5a83.webp";